import { ProductVariantSerializer } from "@app-contexts/public/features/products/data/types/products";
import Box from "@ui-kit/layout/Box/Box.web";
import Select from "@ui-kit/form/Select/Select.web";
import { useTranslation } from "@shared/utils/internationalization";
import React, { Dispatch, SetStateAction } from "react";

export type ProductVariantSelectProps = {
  productVariants: ProductVariantSerializer[];
  selectedProductVariant: ProductVariantSerializer;
  setSelectedProductVariant: Dispatch<SetStateAction<ProductVariantSerializer>>;
  isModalStyling?: boolean;
};

const ProductVariantSelect: React.FC<ProductVariantSelectProps> = ({
  productVariants,
  selectedProductVariant,
  setSelectedProductVariant,
  isModalStyling = false,
}): JSX.Element => {
  const { t } = useTranslation("purchases");

  return (
    <Box width={isModalStyling ? "100%" : "160px"}>
      <Select
        id="item-variants"
        variant="secondary"
        placeholder={t("Select a variant")}
        items={productVariants}
        selectedItem={selectedProductVariant}
        onSelectedItemChange={({ selectedItem }) => {
          setSelectedProductVariant(selectedItem);
        }}
        dropdownHeight={selectedProductVariant ? "140px" : "100px"}
        disablePlaceholderSelection
      />
    </Box>
  );
};

export default ProductVariantSelect;
